import React from 'react';

import ListPreview, { PreviewItem } from 'components/AggregationCards/ListPreview';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import Section from 'components/Section';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { GroupedListModel } from 'models/groupedList';
import GroupList from 'screens/containers/GroupSelectList';

interface Props {
  show: boolean;
  originGroup?: string;
  isFromSelection?: boolean;
  currentGroup: GroupedListModel[];
  previewItems: PreviewItem[];
  groupTarget?: string;
  selectedGroupsRules?: any;
  onCloseModal: () => void;
  onConfirmSelection: (group: GroupedListModel[]) => void;
  onAdd: () => void;
}

const Groups = ({
  show,
  originGroup,
  isFromSelection,
  currentGroup,
  previewItems,
  onCloseModal,
  onConfirmSelection,
  groupTarget,
  onAdd,
  selectedGroupsRules,
}: Props) => {
  const { t } = useStoreTranslation();
  const groupItems: PreviewItem[] = isFromSelection
    ? [{ title: originGroup || t('rule.groups.groupDefaultValue') }]
    : previewItems;

  const handleClickListPreview = () => {
    if (!isFromSelection) onAdd();
  };

  return (
    <Section title={t('rule.groups.header')} details={t('rule.groupsLabel')} joinContent>
      <ListPreview
        multipleColumns
        icon="user"
        showInitials
        placeholder={t('rule.addGroups')}
        previewItems={groupItems}
        onClick={handleClickListPreview}
        onAdd={handleClickListPreview}
      />
      <ApplicationOverlayContent sidebar show={show} onClose={onCloseModal}>
        <GroupList
          showGroupsSelection={show}
          onConfirmSelection={onConfirmSelection}
          onCloseSelectionScreen={onCloseModal}
          currentGroup={currentGroup}
          groupTarget={groupTarget}
          selectedGroupsRules={selectedGroupsRules}
          changeModalTitleKey="rule.groups.bottomSheetTitle"
          changeModalMessageKey="rule.groups.sameRule"
        />
      </ApplicationOverlayContent>
    </Section>
  );
};

export default Groups;
